module.exports = __webpack_public_path__ + "static/media/ADsticker001.661cb211.png";